import { render, staticRenderFns } from "./DetailsTable.vue?vue&type=template&id=6d5ac5e4&"
import script from "./DetailsTable.vue?vue&type=script&lang=js&"
export * from "./DetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports